<script>
    export default {
        name: "PromocodeHelp",
        data() {
            return {
                helpList: [
                    {
                        icon: "icon_1",
                        text: "Проверьте, правильно&nbsp;ли выбран промокод для рюкзака.",
                    },
                    {
                        icon: "icon_2",
                        text: "Возможно, на&nbsp;товар уже действует скидка. В&nbsp;таком случае промокод может не&nbsp;сработать",
                    },
                    {
                        icon: "icon_3",
                        text: "Если промокод выбран верно, а&nbsp;скидки нет, напишите нам в&nbsp;чат на&nbsp;сайте. Мы&nbsp;поможем!",
                    },
                ],
            };
        },
    };
</script>

<template>
    <div class="promocode-help">
        <h2 class="promocode-help__title promocode__title">
            Упс, промокод не сработал. <span>Что делать?</span>
        </h2>
        <div class="promocode-help__list">
            <div class="promocode-help__item" v-for="(help, i) in helpList" :key="i">
                <img
                    class="promocode-help__item-icon"
                    :src="`/static/xd-design/promocode/${help.icon}.svg`"
                    alt=""
                />
                <div class="promocode-help__item-text" v-html="help.text"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-help__title {
        margin-bottom: 30px;

        @include bp($bp-tablet-md) {
            text-align: center;
            margin-bottom: 50px;
        }
    }
    .promocode-help__list {
        margin-bottom: 96px;

        @include bp($bp-tablet-md) {
            display: flex;
            justify-content: space-between;
        }
    }

    .promocode-help__item {
        width: 100%;
        max-width: 500px;
        display: flex;
        align-items: center;

        &:not(:first-child) {
            margin-top: 24px;

            @include bp($bp-tablet-md) {
                margin-top: 0;
            }
        }

        @include bp($bp-tablet-md) {
            max-width: 358px;
        }
    }
    .promocode-help__item-icon {
        max-width: 50px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .promocode-help__item-text {
        font-size: 14px;
        line-height: 26px;
        color: var(--primary-text);
        font-weight: 300;

        @include bp($bp-desktop-sm) {
            font-size: 16px;
        }
    }
</style>
